import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Moment from "moment";

import { useSelector } from "react-redux";

import Loader from "../Loader";
import { localAssetUrl } from "../../utils/assets";
import { getDisplayEmail } from "../../utils/userDisplay";
import "./Profile.css";

const formatDisplayDate = (value) => {
  if (!value) return "--";
  const parsed = Moment(value);
  return parsed.isValid() ? parsed.format("DD MMM YYYY") : "--";
};

const Profile = ({ history }) => {
  const { user, loading } = useSelector((state) => state.auth);

  const displayEmail = getDisplayEmail(user?.email);
  const isSchoolStudent = Boolean(user?.schoolId && user?.studentId);

  const isProfileIncomplete =
    !user?.first_name ||
    !user?.last_name ||
    (!displayEmail && !isSchoolStudent) ||
    !user?.dob ||
    !user?.mobile_number ||
    !user?.gender ||
    !user?.nationality;

  const userInitials =
    `${user?.first_name?.trim()?.[0] || ""}${user?.last_name?.trim()?.[0] || ""}`.toUpperCase() ||
    "ST";

  const fullName = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "--";

  const phoneDisplay =
    user?.mobile_number && user?.mobile_code
      ? `+${user.mobile_code} ${user.mobile_number}`
      : user?.mobile_number
        ? user.mobile_number
        : "--";

  const genderDisplay =
    user?.gender === "F" ? "Female" : user?.gender === "M" ? "Male" : user?.gender || "--";

  const profileFields = [
    { label: "Customer Name", icon: "fas fa-user", value: fullName },
    { label: "User Phone", icon: "fas fa-phone", value: phoneDisplay },
    { label: "Gender", icon: "fas fa-venus-mars", value: genderDisplay },
    { label: "Joined On", icon: "fas fa-calendar-alt", value: formatDisplayDate(user?.createdAt) },
    { label: "Nationality", icon: "fas fa-globe", value: user?.nationality || "--" },
    ...(isSchoolStudent
      ? [{ label: "Student ID", icon: "fas fa-id-card", value: user.studentId || "--" }]
      : []),
    { label: "Email ID", icon: "fas fa-envelope", value: displayEmail || "--" },
    { label: "Date of Birth", icon: "fas fa-calendar", value: formatDisplayDate(user?.dob) },
  ];

  const goToEditUser = () => {
    history.push("/profile/edit");
  };

  return (
    <Fragment>
      {loading ? (
        <Loader />
      ) : (
        <div className="student-account">
          <h1 className="student-account__title">My Account</h1>

          {isProfileIncomplete && (
            <div className="student-account__banner" role="alert">
              Keep your profile up to date to receive promotions and birthday messages tailored to
              you.
            </div>
          )}

          <div className="student-account__profile-card">
            <div className="student-account__avatar">
              {user?.profileImage ? (
                <img src={localAssetUrl(`assets/img/${user.profileImage}`)} alt="" />
              ) : (
                <span>{userInitials}</span>
              )}
            </div>
            <div className="student-account__profile-main">
              <p className="student-account__profile-name">{fullName}</p>
              <p className="student-account__profile-email">
                {displayEmail ||
                  (isSchoolStudent && user?.studentId
                    ? `Student ID: ${user.studentId}`
                    : "--")}
              </p>
            </div>
            <button type="button" className="student-account__edit-btn" onClick={goToEditUser}>
              <i className="fas fa-pencil-alt" aria-hidden="true" />
              Edit Profile
            </button>
          </div>

          <div className="student-account__card">
            <h2 className="student-account__card-title">Profile Information</h2>
            <div className="student-account__info-grid">
              {profileFields.map((field) => (
                <div key={field.label} className="student-account__field">
                  <p className="student-account__field-label">
                    <i className={field.icon} aria-hidden="true" />
                    {field.label}
                  </p>
                  <p className="student-account__field-value">{field.value}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="student-account__card">
            <h2 className="student-account__card-title">Account Actions</h2>
            <div className="student-account__actions">
              <Link to="/account-setting" className="student-account__action">
                <span className="student-account__action-icon student-account__action-icon--green">
                  <i className="fas fa-shield-alt" aria-hidden="true" />
                </span>
                <span className="student-account__action-label">Change Password</span>
              </Link>
              <Link to="/my-subscriptions" className="student-account__action">
                <span className="student-account__action-icon student-account__action-icon--blue">
                  <i className="fas fa-credit-card" aria-hidden="true" />
                </span>
                <span className="student-account__action-label">My Subscriptions</span>
              </Link>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Profile;
